/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/layout'

const financeManageRouter = {
  path: '/financeManage',
  component: Layout,
  hidden: false,
  redirect: 'noredirect',
  name: 'FinanceManage',
  meta: {
    title: '财务管理',
    icon: 'finance',
    roles: ['admin']
  },
  children: [
    // {
    //   path: 'tradeReport',
    //   component: resolve => require(['@/views/manage/financeManage/tradeReport'], resolve),
    //   name: 'TradeReport',
    //   meta: { title: '系统未出金额报表', noCache: false }
    // },
    // {
    //   path: 'merchantDefBalance',
    //   component: resolve => require(['@/views/manage/financeManage/merchantDefBalance'], resolve),
    //   name: 'MerchantDefBalance',
    //   meta: { title: 'merchantDefBalance', noCache: false }
    // },
    // {
    //   path: 'virtualAccount',
    //   component: resolve => require(['@/views/manage/financeManage/virtualAccount'], resolve),
    //   name: 'VirtualAccount',
    //   meta: { title: '商户加减款', noCache: false }
    // },
    // {
    //   path: 'virtualAccountList',
    //   component: resolve => require(['@/views/manage/financeManage/virtualAccountList'], resolve),
    //   name: 'VirtualAccountList',
    //   meta: { title: '虚拟商户列表', noCache: false }
    // },
    {
      path: 'merchantWithdrawOrder',
      component: resolve => require(['@/views/manage/merchantAccountManage/merchantWithdrawOrder'], resolve),
      name: 'MerchantWithdrawOrder',
      meta: { title: '代收商户提现订单', noCache: false, noKeepAlive: true }
    },
    // {
    //   path: 'withdrawBlacklist',
    //   component: resolve => require(['@/views/manage/financeManage/withdrawBlacklist'], resolve),
    //   name: 'WithdrawBlacklist',
    //   meta: { title: '黑名单银行卡管理', noCache: false }
    // },//2023-06-28移到系统管理
    // {
    //   path: 'blacklistIDcard',
    //   component: resolve => require(['@/views/manage/financeManage/blacklistIDcard'], resolve),
    //   name: 'BlacklistIDcard',
    //   meta: { title: '黑名单身份证管理', noCache: false }
    // },
    // {
    //   path: 'blacklistname',
    //   component: resolve => require(['@/views/manage/financeManage/blacklistname'], resolve),
    //   name: 'Blacklistname',
    //   meta: { title: '黑名单姓名管理', noCache: false }
    // },//2023-06-28移到系统管理
    {
      path: 'profitManage',
      component: resolve => require(['@/views/manage/financeManage/profitManage'], resolve),
      name: 'ProfitManage',
      meta: { title: '代理分红管理', noCache: false }
    },
    {
      path: 'balanceSnapshot',
      component: resolve => require(['@/views/manage/financeManage/balanceSnapshot'], resolve),
      name: 'BalanceSnapshot',
      meta: { title: '余额快照', noCache: false }
    },
    {
      path: 'balanceObvious/:id',
      component: resolve => require(['@/views/manage/financeManage/balanceObvious'], resolve),
      hidden: true,
      name: 'BalanceObvious',
      meta: { title: '余额快照明细', noCache: false }
    },
    // {
    //   path: 'bankStatement-258',
    //   component: resolve => require(['@/views/manage/financeManage/bankStatement'], resolve),
    //   name: 'BankStatement',
    //   meta: { title: '银行账单', noCache: false }
    // },
    // {
    //   path: 'MaleWithdrawalApprove',
    //   component: resolve => require(['@/views/manage/financeManage/MaleWithdrawalApprove'], resolve),
    //   name: 'MaleWithdrawalApprove',
    //   meta: { title: '对公代付审核', noCache: false }
    // },
    {
      path: 'cutManagement-309',
      component: resolve => require(['@/views/manage/financeManage/cutManagement'], resolve),
      name: 'CutManagement',
      meta: { title: '日切管理', noCache: false }
    }
  ]
}

export default financeManageRouter



// WEBPACK FOOTER //
// ./src/router/manage/financeManage.js